export default {
  admin: 'المسؤول',
  password: {
    enterNewPassword: 'أدخل كلمة مرور جديدة',
    reenterNewPassword: 'أعد إدخال كلمة المرور الجديدة',
    updatePassword: 'تحديث كلمة المرور',
    setPassword: 'تعيين كلمة المرور',
    min8CharacterMessage: 'يجب أن تتكون كلمة المرور من 8 أحرف على الأقل',
    passwordSentMessage: 'تم إرسال كلمة المرور إلى {userName} عبر البريد الإلكتروني.',
    generateNewPassword: 'إنشاء كلمة مرور جديدة',
    assignPasswordMessage: 'قم بتعيين كلمة مرور للمستخدم. سيُطلب من المستخدم تغيير هذه الكلمة عند تسجيل الدخول التالي.',
    generateSecurePassword: 'إنشاء كلمة مرور آمنة',
    newPassword: 'كلمة مرور جديدة',
    confirmNewPassword: 'تأكيد كلمة المرور الجديدة',
    passwordHistory: 'سجل كلمات المرور',
    passwordUpdatedLog: 'تم تحديث كلمة المرور بواسطة {userName} في {date}.',
    forgotPasswordLog: 'تم إرسال طلب استعادة كلمة المرور بواسطة {userName} في {date}.',
  },
};
